/**
 * Messaging API service (RULE §13: API layer separate from components).
 * All methods use api from axiosConfig; start-conversation unwraps ApiResponse envelope.
 */
import api from './api/axiosConfig';

const unwrap = (d) =>
  d && typeof d.success === 'boolean' && d.data !== undefined ? d.data : d;

const messagingService = {
  getConversations: async (params = {}) => {
    const response = await api.get('/messaging/conversations/', { params });
    return response.data;
  },

  getConversation: async (id) => {
    const response = await api.get(`/messaging/conversations/${id}/`);
    return response.data;
  },

  getMessages: async (conversationId, params = {}) => {
    const response = await api.get(
      `/messaging/conversations/${conversationId}/messages/`,
      { params }
    );
    return response.data;
  },

  sendMessage: async (conversationId, payload) => {
    const response = await api.post('/messaging/messages/', {
      conversation: conversationId,
      message_type: payload.message_type || 'text',
      content: payload.content || '',
      ...payload,
    });
    return response.data;
  },

  markConversationRead: async (conversationId) => {
    const response = await api.post(
      `/messaging/conversations/${conversationId}/mark_as_read/`
    );
    return response.data;
  },

  deleteConversation: async (conversationId) => {
    const response = await api.delete(`/messaging/conversations/${conversationId}/`);
    return response.data;
  },

  editMessage: async (messageId, content) => {
    const response = await api.patch(`/messaging/messages/${messageId}/edit/`, {
      content: content?.trim() ?? '',
    });
    return response.data;
  },

  deleteMessage: async (messageId) => {
    const response = await api.delete(`/messaging/messages/${messageId}/soft_delete/`);
    return response.data;
  },

  startConversationFromAd: async (adIdentifier) => {
    const response = await api.post(
      `/ads/${adIdentifier}/start-conversation/`,
      {},
      { headers: { 'Content-Type': 'application/json' } }
    );
    return unwrap(response.data);
  },

  startConversationFromOrder: async (orderId) => {
    const response = await api.post(
      `/store/orders/${orderId}/start-conversation/`,
      {},
      { headers: { 'Content-Type': 'application/json' } }
    );
    return unwrap(response.data);
  },
};

export default messagingService;
